import { graftPlainString } from '@common/utils/readGraftObject'

import type { Workspace } from '@modules/workspaces/workspaces.type'

import { ORGANIZATION_ROLE } from '../../settings.const'
import type { Organization } from '../../settings.interface'

export function mapWorkspaceToOrganization(workspace: Workspace): Organization {
  return {
    id: graftPlainString(workspace.workspaceId),
    name: graftPlainString(workspace.name),
    logo: [],
    logoUrl: workspace.logoUrl ?? null,
    joinedAt: workspace.createdAt ?? workspace.created ?? null,
    role: ORGANIZATION_ROLE.OWNER,
  }
}
